<template>
	<Confirmation
		@agree="$emit('agree', duration)"
		@cancel="$emit('cancel')">
		<v-card-text class="pa-4">
			<span class="confirmation-message text-body-2" v-html="message"></span>
			<div class="text-center">
				<p class="mb-4">Edit Spot Block Target Length</p>
				<div class="d-flex justify-center align-baseline">
					<v-text-field variant="outlined" density="compact" hide-details
						type="number"
						v-model="duration.minutes"
						class="col-2 px-2"
						min="0"
						placeholder="mm"/>
					<v-text-field variant="outlined" density="compact" hide-details
						type="number"
						v-model="duration.seconds"
						class="col-2 px-2"
						min="0"
						placeholder="ss"/>
				</div>
			</div>
		</v-card-text>
	</Confirmation>

</template>

<script>

import Confirmation from "@/components/dialogs/Confirmation.vue";

export default {
	name: "SpotBlockConfirmation",

	components: {Confirmation},

	props: ["title", "message"],

	emits: ["agree", "cancel"],

	data() {
		return {
			duration: {
				minutes: null,
				seconds: null
			}
		}
	}
}
</script>

<style scoped lang="scss">
.confirmation-message {
	white-space: pre-wrap;
	justify-content: center;
	display: flex;
	flex-direction: column;
}
</style>